import { useEffect } from 'react';

/**
 * Sets the document title with a consistent suffix.
 * Example: useDocumentTitle('Meine Seiten') → "Meine Seiten – Symbolbuch.de"
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const base = 'Symbolbuch.de';
    document.title = title ? `${title} – ${base}` : `${base} – Kommunikationsseiten mit Piktogrammen für Unterstützte Kommunikation (UK)`;
    return () => {
      document.title = `${base} – Kommunikationsseiten mit Piktogrammen für Unterstützte Kommunikation (UK)`;
    };
  }, [title]);
}
